import { render, staticRenderFns } from "./CrashLog.vue?vue&type=template&id=3490ab3e&scoped=true&"
import script from "./CrashLog.vue?vue&type=script&lang=js&"
export * from "./CrashLog.vue?vue&type=script&lang=js&"
import style0 from "./CrashLog.vue?vue&type=style&index=0&id=3490ab3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490ab3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3490ab3e')) {
      api.createRecord('3490ab3e', component.options)
    } else {
      api.reload('3490ab3e', component.options)
    }
    module.hot.accept("./CrashLog.vue?vue&type=template&id=3490ab3e&scoped=true&", function () {
      api.rerender('3490ab3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notification/CrashLog.vue"
export default component.exports